import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ServicesService } from "../services.service";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpErrorResponse } from "@angular/common/http";
import { passwordMatchValidator } from "../validators/passwordmatch.validator";
import swal from "sweetalert2";

@Component({
  selector: "app-forget-password",
  templateUrl: "./forget-password.component.html",
  styleUrls: ["./forget-password.component.css"]
})
export class ForgetPasswordComponent implements OnInit {
  header = "l-header";
  navbar = "l-navbar l-navbar_t-light l-navbar_expand js-navbar-sticky";
  forgetPasswordForm: FormGroup;
  token;
  email;
  constructor(private route: ActivatedRoute, private _service: ServicesService, private router: Router) {}

  ngOnInit() {
    this.forgetPasswordForm = new FormGroup({
      password: new FormControl("", [Validators.required]),
      password_confirmation: new FormControl("", [Validators.required, passwordMatchValidator("password")])
    });
  }

  resetPassword() {
    this.route.queryParams.subscribe(params => {
      this.token = params["token"];
      this.email = params["email"];
    });
    this.forgetPasswordForm.value.email = this.email ? this.email : "";
    this.forgetPasswordForm.value.token = this.token ? this.token : "";
    this._service.resetPassword(this.forgetPasswordForm.value).subscribe(
      (data: any) => {
        if (data.status == 200) {
          var that = this;
          swal({
            title: "Success",
            text: "Password Changed Successfully. Please re-login with new password.",
            type: "success"
          }).then(function(isConfirm) {
            that.router.navigate(["login"]);
          });
        } else {
          swal({
            title: "Oops!",
            text: "Your token has been expired. Please use forget password option again to change your password",
            type: "error"
          });
        }
      },
      (err: HttpErrorResponse) => {}
    );
  }
}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/forget-password/forget-password.component.ts